import axios from 'axios'
import Vue from 'vue'
import { storeAllEntities } from '@/helpers/store'
import qs from 'qs'

export default {
  state: {
    // actions is an ordered list of actions
    courses: {},
    events: {},
    course_event_ids: {},
    groups: {},
    serie_rules: {},
    event_series: {},
    event_serie_events: {},
    event_clusters: {},
    event_serie_groups: {},
    coloured_clusters: [],
    loading: false,

    // actual models for MatrixOverview
    eventClusters: {},
    studentClusters: {},
    studentSeries: {},
  },
  mutations: {
    ADD_EVENTS (state, { courseId, events }) {
      Vue.set(state.events, courseId, events)
    },
    REMOVE_EVENTS (state, courseId) {
      Vue.delete(state.events, courseId)
    },
    UPDATE_COURSE_EVENT_IDS (state, { courseId, eventIds }) {
      Vue.set(state.course_event_ids, courseId, eventIds)
    },
    REMOVE_COURSE_EVENT_IDS (state, courseId) {
      Vue.delete(state.course_event_ids, courseId)
    },
    ADD_COURSE (state, course) {
      Vue.set(state.courses, course.id, {
        id: course.id,
        title: course.title,
        event_ids: course.event_ids,
        types: course.types,
        group_ids: course.group_ids,
        chosen_eventTypes: null,
        chosen_startdate: null,
        chosen_enddate: null,
        chosen_groupIds: null,
        chosen_eventNames: null,
        added_on: (new Date()).getTime(),
      })
    },
    UPDATE_COURSE (state, { courseId, name, value }) {
      state.courses[courseId][name] = value
    },
    REMOVE_COURSE (state, courseId) {
      Vue.delete(state.courses, courseId)
    },
    ADD_GROUPS (state, group) {
      Vue.set(state.groups, group.id, {
        id: group.id,
        name: group.name,
      })
    },
    ADD_SERIE_RULES (state) {
      Vue.set(state.serie_rules, 'type', null)
      Vue.set(state.serie_rules, 'per_week', 1)
      Vue.set(state.serie_rules, 'serie_goal_type', 'all')
      Vue.set(state.serie_rules, 'serie_goal_number', null)
      Vue.set(state.serie_rules, 'allow_shopping', true)
      Vue.set(state.serie_rules, 'goal_name', null)
    },
    UPDATE_SERIE_RULES (state, { rule, value }) {
      Vue.set(state.serie_rules, rule, value)
    },
    ADD_EVENT_SERIE (state, { event_serie }) {
      Vue.set(state.event_series, event_serie.id, event_serie)
    },
    ADD_EVENT_CLUSTER (state, { event_cluster }) {
      Vue.set(state.event_clusters, event_cluster.id, event_cluster)
    },
    ADD_EVENT_SERIE_EVENTS (state, { event }) {
      Vue.set(state.event_serie_events, event.id, event)
    },
    ADD_EVENT_SERIE_GROUPS (state, { group }) {
      Vue.set(state.event_serie_groups, group.id, group)
    },
    DELETE_EVENT_SERIES (state) {
      state.event_series = {}
      state.event_clusters = {}
    },
    UPDATE_EVENT_CLUSTER_LABEL (state, { event_cluster_id, label }) {
      state.event_clusters[event_cluster_id].attributes.label = label
    },
    ADD_COLOURED_CLUSTERS (state, eventClusterIds) {
      state.coloured_clusters = eventClusterIds
    },
    CHANGE_LOADING (state, loading) {
      state.loading = loading
    },
  },
  actions: {
    add_course ({ commit, state }, { courseId }) {
      if (!Object.keys(state.courses).includes(courseId)) {
        return axios.get(`/employee/event-series/course-api/${courseId}`).then(({ data }) => {
          const course = data.course
          const events = data.events
          const eventIds = data.course.event_ids
          const groups = data.groups
          commit('ADD_COURSE', course)
          commit('UPDATE_COURSE_EVENT_IDS', { courseId, eventIds })
          commit('ADD_EVENTS', { courseId, events })
          return groups.forEach(group => {
            if (!state.groups.hasOwnProperty(group.id)) {
              commit('ADD_GROUPS', group)
            }
          })
        })
      } else {
        const eventIds = state.course[courseId].event_ids
        return commit('UPDATE_COURSE_EVENT_IDS', { courseId, eventIds })
      }
    },
    update_course ({ commit, state }, { courseId, name, value }) {
      return commit('UPDATE_COURSE', { courseId, name, value })
    },
    remove_course ({ commit, state }, courseId) {
      commit('REMOVE_COURSE_EVENT_IDS', courseId)
      commit('REMOVE_EVENTS', courseId)
      return commit('REMOVE_COURSE', courseId)
    },
    update_course_event_ids ({ commit, state }, { courseId, eventIds }) {
      return commit('UPDATE_COURSE_EVENT_IDS', { courseId, eventIds })
    },
    add_serie_rules ({ commit, state }) {
      return commit('ADD_SERIE_RULES')
    },
    update_serie_rules ({ commit, state }, { rule, value }) {
      commit('UPDATE_SERIE_RULES', { rule, value })
    },
    empty_event_series ({ commit, state }) {
      commit('DELETE_EVENT_SERIES')
    },
    update_event_series ({ commit, state }, { data }) {
      commit('DELETE_EVENT_SERIES')
      const eventSeries = Object.values(data.data)
      const included = Object.values(data.included)
      const eventClusters = included.filter(included => {
        return included.type === 'event_clusters'
      })
      const events = included.filter(included => {
        return included.type === 'events'
      })
      const groups = included.filter(included => {
        return included.type === 'groups'
      })
      Object.values(eventSeries).forEach(eventSerie => {
        commit('ADD_EVENT_SERIE', { event_serie: eventSerie })
      })
      Object.values(eventClusters).forEach(eventCluster => {
        commit('ADD_EVENT_CLUSTER', { event_cluster: eventCluster })
      })
      Object.values(events).forEach(event => {
        commit('ADD_EVENT_SERIE_EVENTS', { event })
      })
      Object.values(groups).forEach(group => {
        commit('ADD_EVENT_SERIE_GROUPS', { group })
      })
      return data
    },
    update_event_cluster_labels ({ commit, state }, { event_cluster_ids, label }) {
      event_cluster_ids.forEach((eventClusterId, index) => {
        const setLabel = index > 0 ? label + ' ' + String(index + 1) : label
        commit('UPDATE_EVENT_CLUSTER_LABEL', { event_cluster_id: eventClusterId, label: setLabel })
      })
    },
    add_coloured_clusters ({ commit, state }, { event_cluster_ids }) {
      commit('ADD_COLOURED_CLUSTERS', event_cluster_ids)
    },
    change_loading_series ({ commit, state }, { loading }) {
      return commit('CHANGE_LOADING', loading)
    },

    getAttendanceGoalMatrixClusters ({ commit }, { eventSerieId }) {
      return axios.get(`/employee/attendance-goals/${eventSerieId}/clusters-api`)
        .then(storeAllEntities(commit))
    },
    getAttendanceGoalMatrixStudents ({ commit }, { eventSerieId }) {
      return axios.get(`/employee/attendance-goals/${eventSerieId}/students-api`)
        .then(storeAllEntities(commit))
    },
    getAttendanceGoalMatrixDetails ({ commit }, { eventSerieId, queryParams = null }) {
      return axios.get(`/employee/attendance-goals/${eventSerieId}/matrix-api`, {
        params: queryParams,
        paramsSerializer: params => {
          return qs.stringify(params)
        },
      }).then(storeAllEntities(commit))
    },

    getEventClusterDetails ({ commit }, { eventSerieId, eventClusterId }) {
      return axios.get(`/employee/series/${eventSerieId}/clusters/${eventClusterId}/show`)
    },
    getStudentClusterDetails ({ commit }, { eventSerieId, eventClusterId, studentId }) {
      return axios.get(`/employee/series/${eventSerieId}/clusters/${eventClusterId}/students/${studentId}/show`)
    },
  },
  getters: {},
}
